export default __webpack_public_path__ + "assets/search-scope-file.svg";